import React from 'react'
import { Box } from "@mui/material";
import InfoCard from './InfoCard';
import { useOutletContext } from 'react-router';
import { getOrgDepartments } from '../../../../../../../services/globalData';

const PersonalDetails = () => {
  const [employeeData] = useOutletContext();
  const department = (getOrgDepartments() || []).find(dep => dep._id === employeeData?.department)?.name;

  const basicInfo = [
                      {label:"Profile Image",value:employeeData?.profileImage, field:"profileImage"},
                      {label:"First Name",value:employeeData?.fname, field:"fname"},
                      {label:"Last Name",value:employeeData?.lname, field:"lname"},
                      {label:"Employee Id",value:employeeData?.aliasId, field:"aliasId"},
                      {label:"Designation",value:employeeData?.designation, field:"designation"},
                      {label:"Department",value:department, field:"department"},
                      {label:"Date of Joining",value:employeeData?.joiningDate?.split("T")[0], field:"joiningDate"}
                   ]

  const personalInfo = [
                        {label:"Date of Birth",value:employeeData?.dob, field:"dob"},
                        {label:"Father's Name",value:employeeData?.fatherName, field:"fatherName"},
                        {label:"Mother's Name",value:employeeData?.motherName, field:"motherName"},
                        {label:"Mobile Number",value:employeeData?.phone, field:"phone"},
                        {label:"Nationality",value:employeeData?.nationality, field:"nationality"},
                        {label:"Visa Sponsorship",value:employeeData?.workAuthorisation, field:"workAuthorisation", options:["Yes","No"]},
                        {label:"Place Of Birth",value:employeeData?.placeOfBirth, field:"placeOfBirth"},
                        {label:"Residential Status",value:employeeData?.residentialStatus, field:"residentialStatus",
                         options:["Born or Naturalized Citizen","Resident or Green Card Holder","Temporary Non-Immigrant","Undocumented Immigrants"]},
                       ]

  const contactInfo = [
                        {label:"Phone Number",value:employeeData?.phone, field:"phone"},
                        {label:"Personal Email Id",value:employeeData?.email, field:"email"},
                        {label:"Present Address",value:employeeData?.presentStreet, field:"presentStreet"},
                        {label:"Pin Code",value:employeeData?.presentPincode, field:"presentPincode"},
                        {label:"Emergency Contact Name",value:employeeData?.emergencyContactName, field:"emergencyContactName"},
                        {label:"Emergency Contact Number",value:employeeData?.emergencyContactNumber, field:"emergencyContactNumber"},
                      ]

  const identityInfo = [
                        {label:"Permanent Account Number (PAN)",value:employeeData?.panNumber, field:"panNumber"},
                        {label:"UAN",value:employeeData?.uanNumber, field:"uanNumber"},
                        {label:"Aadhaar (masked)",value:employeeData?.aadharNumber, field:"aadharNumber"},
                        {label:"IP Number",value:employeeData?.ipNumber, field:"ipNumber"},
                       ]

  const bankInfo = [
                     {label:"Account Holder Name",value:employeeData?.accholderName, field:"accholderName"},
                     {label:"Account Number",value:employeeData?.accNumber, field:"accNumber"},
                     {label:"IFSC Code",value:employeeData?.ifscCode, field:"ifscCode"},
                     {label:"Bank Name",value:employeeData?.bankName, field:"bankName"},
                     {label:"Branch Name",value:employeeData?.bankBranch, field:"bankBranch"},
                     {label:"Account Type",value:employeeData?.accType, field:"accType"},
                     {label:"Swift Code",value:employeeData?.swiftCode, field:"swiftCode"},
                   ]

  const name = `${employeeData?.fname || ""} ${employeeData?.lname || ""}`.trim();
  const cards = [
    { heading: "Basic Information", data: basicInfo },
    { heading: "Personal Information", data: personalInfo },
    { heading: "Contact Information", data: contactInfo },
    { heading: "Identity Information", data: identityInfo },
    { heading: "Bank Information", data: bankInfo },
  ];

  return (
    <Box sx={{ width: "100%", display: "grid", gridTemplateColumns: { xs: "1fr", lg: "repeat(2, 1fr)" }, gap: "1.5rem", alignItems: "start" }}>
      {cards.map((c) => (
        <InfoCard key={c.heading} headingText={c.heading} data={c.data} employeeId={employeeData?._id} name={name} />
      ))}
    </Box>
  )
}

export default PersonalDetails